import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDollarUpFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.877 12.373a.75.75 0 0 1 .75-.75h2.216a.44.44 0 0 0 .443-.44.44.44 0 0 0-.443-.441H10.48a1.941 1.941 0 0 1-.069-3.882v-.262a.75.75 0 0 1 1.5 0v.254h.784a.75.75 0 0 1 0 1.5H10.48a.443.443 0 0 0-.445.441c0 .247.199.448.445.448h1.363c1.07 0 1.943.87 1.943 1.941a1.94 1.94 0 0 1-1.875 1.934v.261a.75.75 0 0 1-1.5 0v-.255h-.784a.75.75 0 0 1-.75-.75m3.58 2.976 3.183.948a.3.3 0 0 0 .346-.139l.035-.06a.33.33 0 0 0-.048-.38 2 2 0 0 1-.404-.742 2 2 0 0 1 1.373-2.474l2.137-.61.02-.003c.086-.024.176-.035.266-.047.039-.006.078-.019.117-.02q.198-.017.399.01c.188.023.378-.099.39-.289q.017-.27.018-.546c0-4.766-3.876-8.642-8.641-8.642-4.764 0-8.64 3.876-8.64 8.641 0 3.544 2.147 6.59 5.206 7.922a.29.29 0 0 0 .366-.116l1.608-2.591a2.01 2.01 0 0 1 2.27-.862"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.964 15.737-.607-2.106a.8.8 0 0 0-.14-.281c-.033-.042-.077-.07-.117-.103-.033-.027-.058-.061-.096-.083l-.005-.002a.73.73 0 0 0-.377-.084c-.065 0-.13-.001-.191.016h-.008l-2.137.61a.75.75 0 0 0-.514.928.74.74 0 0 0 .926.514l.368-.105-1.605 2.805-4.36-1.3a.754.754 0 0 0-.852.324L8.996 20.5a.752.752 0 0 0 .637 1.145.75.75 0 0 0 .639-.354l1.95-3.143 4.38 1.306c.33.1.692-.044.866-.347L19.4 15.73l.122.423a.75.75 0 1 0 1.44-.416"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDollarUpFilled);
export default ForwardRef;
